import React from 'react';
import styled from 'styled-components';
import Link from 'next/link';
import { Grid } from 'planoplan-ui-kit/core/helpers/grid';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { Mixins } from 'planoplan-ui-kit/core/mixins';
import { deviceDetected } from 'planoplan-ui-kit/core/device-detected';
import { textSize } from '@styles';
import { IEye } from 'planoplan-ui-kit/core/icons/i-eye';
import { ILove } from 'planoplan-ui-kit/core/icons/i-love';
import { IRooms } from 'planoplan-ui-kit/core/icons/i-rooms';
import { IArea } from 'planoplan-ui-kit/core/icons/i-area';
import { GALLERY_PATH } from '@constants';
import { useTranslations } from '@libs/translations';

export const Card = ({ project }) => {
  const href = `/${GALLERY_PATH}/p/${project.address.toLowerCase()}/`;
  const translations = useTranslations();

  return (
    <Container>
      <Link href={href}>
        <a>
          <ImageWrap>
            <Image>
              <img src={project.image} alt={project.title}/>
            </Image>
          </ImageWrap>

          <Content>
            <Information>
              {/*<InfoWrap>
            <Info>
              <IEye width="16px" height="16px" fill={Colors.black} />
              <span>365</span>
            </Info>

            <Info>
              <ILove width="16px" height="16px" fill={Colors.black} />
              <span>30</span>
            </Info>
          </InfoWrap>*/}

              <InfoWrap>
                <Info>
                  <IRooms width="16px" height="16px" fill={Colors.black} />
                  <span>{translations.t(project.room)}</span>
                </Info>

                <Info>
                  <IArea width="16px" height="16px" fill={Colors.black} />
                  <span>{project.area}m&sup2;</span>
                </Info>
              </InfoWrap>
            </Information>

            <Name>
              {project.title}
            </Name>

            <Tags>
              {project['tags_style'].map((tag) => (
                  tag && <Tag key={tag.id}>{tag.name.toLowerCase()}</Tag>
              ))}

              {project['tags_room'].map((tag) => (
                  tag && <Tag key={tag.id}>{tag.name.toLowerCase()}</Tag>
              ))}
            </Tags>
          </Content>
        </a>
      </Link>
    </Container>
  )
};

const Container = styled.div`
  ${Mixins.transition('transform')};
  background-color: ${Colors.white};
  border-radius: 20px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.04), 0 2px 6px rgba(0, 0, 0, 0.04), 0 0 1px rgba(0, 0, 0, 0.04);
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
  
  &:hover {
    transform: translate(0, -5px);
  }
  
  & > a {
    text-decoration: none;
    color: inherit;
    display: flex;
    flex-direction: column;
    height: 100%;
  }
`;

const ImageWrap = styled.div`
  background-color: #eee;
  height: 0;
  padding-top: 100%;
  position: relative;
  flex-grow: 1;
`;

const Image = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${Colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  
  img {
    max-width: 100%;
    max-height: 100%;
  }
`;

const Content = styled.div`
  padding: 10px 20px;
`;

const Information = styled.div`
  ${textSize('p3')};
  display: flex;
  justify-content: space-between;
`;

const InfoWrap = styled.div`
  display: flex;
`;

const Info = styled.div`
  display: flex;
  align-items: center;
  
  &:not(:first-child) {
    margin-left: 10px;
  }
  
  span {
    margin-left: 2px;
  }
`;

const Name = styled.div`
  ${textSize('p2')};
  padding-top: 10px;
  color: ${Colors.night};
  font-weight: 500;
  
  a {
    text-decoration: none;
    color: inherit;
  }
`;

const Tags = styled.ul`
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  margin: 0;
  padding: 10px 0 0;
`;

const Tag = styled.li`
  ${textSize('p3')};
  margin-right: 4px;
  margin-bottom: 10px;
  display: block;
  padding: 4px 10px;
  border-radius: 20px;
  border: 1px solid #4A4A4A;
  color: ${Colors.black};
`;
